<template>
  <transition>
    <div v-if="isShow" name="modal">
      <div class="modal-mask">
          <div class="modal-wrapper" @click="cancel">
            <div id="content" @click.stop="">
              <div class="modal-text">Edit Time</div>
              <div class="change-status">
                <label>
                  <font-awesome-icon
                    v-if="type === 'clockin'"
                    :icon="'check'"
                    class="password-lock"
                  />
                  ClockIn
                </label>
                <label>
                  <font-awesome-icon
                    v-if="type === 'waiting'"
                    :icon="'check'"
                    class="password-lock"
                  />
                  Waiting
                </label>
              </div>
              <div class="before-time">
                <label>{{beforeHour}}</label>
                <span class="colon">:</span>
                <label>{{beforeMinute}}</label>
              </div>
              <div class="time">
                <input
                  type="number"
                  min="0"
                  max="23"
                  v-model="hour"
                >
                <span class="colon">:</span>
                <input
                  type="number"
                  min="0"
                  max="59"
                  v-model="minute"
                >
              </div>
              <div class="error-text" v-show="hasError">
                Please punch a clock between 0:00 to 23:59
              </div>
              <div class="button-container">
                <div :class="['ok-button', {'disabled': isLoading}]" @click="editTime">
                  <span v-show="!isLoading">Edit</span>
                  <font-awesome-icon v-show="isLoading" icon="spinner" spin />
                </div>
                <div :class="['cancel-button', {'disabled': isLoading}]" @click="cancel">
                  Cancel
                </div>
              </div>
              <span class="chancel-button" @click="cancel" v-show="!isLoading">
                <font-awesome-icon  icon="times"/>
              </span>
            </div>
          </div>
      </div>
    </div>
  </transition>
</template>

<script>
import _ from 'lodash';

export default {
  data() {
    return {
      attendanceId: '',
      beforeHour: '',
      beforeMinute: '',
      hour: '',
      minute: '',
      type: '',
      isLoading: false,
      isShow: false,
      emittedOk: false,
      hasError: false,
    };
  },
  props: {
    // attributeに設定するとOKボタン押下時にloading表示にする
    isLoadingMode: {
      type: Boolean,
      default: false,
    },

  },
  methods: {
    // モーダルを開く
    open(stamp) {
      Object.assign(this.$data, this.$options.data());
      this.attendanceId = stamp.attendanceId;
      this.beforeHour = stamp.date.format('HH');
      this.beforeMinute = stamp.date.format('mm');
      this.type = stamp.type;
      this.isShow = true;
      this.isLoading = false;
      this.emittedOk = false;
    },

    // モーダルを閉じる
    close() {
      this.isShow = false;
    },

    // editTime押下時
    editTime() {
      if (_.isEmpty(this.hour) || _.isEmpty(this.minute)) {
        this.hasError = true;
        return;
      }

      if (this.hour >= 24 || this.minute >= 60) {
        this.hasError = true;
        return;
      }

      if (this.emittedOk) {
        return;
      }

      this.$emit(
        'ok',
        {
          attendanceId: this.attendanceId,
          time: `${_.padStart(this.hour, 2, '0')}${_.padStart(this.minute, 2, '0')}`,
          type: this.type,
        },
      );

      this.emittedOk = true;
      if (this.isLoadingMode) {
        this.isLoading = true;
      } else {
        this.close();
      }
    },

    // cancel押下時
    cancel() {
      if (!this.isLoading) {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

#content{
  z-index:2;
  width:25%;
  min-width: 300px;
  margin: 0px auto;
  text-align: center;
  padding: 50px 30px 30px 30px;
  background:#fff;
  border-radius: 10px;
  position: relative;
  display: flex;
  transition: all .3s ease;
  flex-direction: column;
  justify-content: space-between;
}

.ok-button, .cancel-button {
  color: #fff;
  padding:10px 20px;
  border-radius: 30px;
  display: block;
  width: 100px;
  margin:auto;
  cursor: pointer;
  transition:.2s;
  font-size: 13px;
}

.ok-button{
  border: 3px solid #1cc8a0;
  background: #1cc8a0;
}

.ok-button:hover {
  background: #fff;
  color:#1cc8a0;
}

.cancel-button{
  border: 3px solid #eee;
  background: #eee;
  color:#000;
}

.cancel-button:hover{
  background: #D8D8D8;
}

.chancel-button {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  line-height: 20px;
  font-size: 20px;
}

.chancel-button:hover {
  opacity:.5;
}

.cancel-button.disabled {
  border: 3px solid #FFFFFF;
  background: #FFFFFF;
  color:#999;
}

.cancel-button.disabled:hover {
  border: 3px solid #FFFFFF;
  background: #FFFFFF;
  color:#999;
}

.check-circle {
  color: #92D050;
  font-size: 75px;
  display: block;
  margin: auto;
  margin-bottom : 20px;
}

.modal-text {
  font-size: 20px;
  margin-bottom:30px;
}

.v-enter-active {
  transition: opacity .3s
}

.v-enter {
  opacity: 0
}

.button-container {
  display: flex;
  margin-top:30px;
}

.time {
  display: flex;
  align-items: center;
  justify-content: center;
}

.before-time {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-bottom:30px;
}

.time input[type="number"] {
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 100px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.colon {
  padding:0 10px
}

.change-status {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding:10px;
  background: #D8D8D8;
  margin-bottom: 30px;
}

.change-status label {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: initial;
}

.change-status label input {
  margin-right:10px;
}

.modal-enter #content,
.modal-leave-active #content {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.text-box {
  margin-bottom:60px;
}

.clockIn-waiting {
  margin-bottom:30px;
  font-size:20px;
  padding:10px;
  background: #DDEAF6;
}

.password-lock , .password-open {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  color: #2E75B5;
}

</style>
